import type { Application } from '@/types/Activity'

export const isEnglishTenancy = (application: Application): boolean =>
  application.assets?.at(0)?.attributes.address.country?.toLocaleLowerCase() === 'england'
